const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/',
    defaultPath: '/main/dashboard/default',
    grantAdvance:'https://grantadvance.com',
    fontFamily: `'Poppins', sans-serif`,
    borderRadius: 12,
    outlinedFilled: true,
    theme: 'light', // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    i18n: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    jwt: {
        secret: 'SECRET-KEY',
        timeout: '1 days'
    },
    auth0: {
        client_id: '7T4IlWis4DKHSbG8JAye4Ipk0rvXkH9V',
        domain: 'dev-w0-vxep3.us.auth0.com'
    },
    welcomeMessage: {
        keyVersion: 'version_3_2_2',
        message: [
            "<p>We’re excited to announce that versions <span style='font-weight: bold;'>V3.2.1</span> and <span style='font-weight: bold;'>V3.2.2</span> of Grant Advance are now live!</p>",
            "<p>These updates include exciting new features like enhanced search tools, AI-powered document generation, and improved profile management, along with essential fixes for a smoother experience.</p>",
            "<p><span style='font-weight: bold;'>Please check out the detailed announcement</span> for more information and resources.</p>"
        ]
    },
    markerOptions: {
        "accuracy": 
        { 
            "value": "exactly", 
            "limiters": ["-", ".", ";", ","]
        } 
    },
    searchEngineYearFilter: {
        CA: 2025,
        US: 2025
    },
    grantMarks: {
        US: [ 
            "No low limit",
            "$200",
            "$1,000",
            "$2,500",
            "$5,000",
            "$10,000",
            "$25,000",
            "$50,000",
            "$100,000",
            "$250,000",
            "$500,000",
            "No upper limit"
        ],
    }
};

export default config;
